import type { enMaps } from './en-maps';

/** Turkish strings — wave-4 maps: big fields, ADVANCE routes, gate notices (docs/01). */
export const trMaps: Record<keyof typeof enMaps, string> = {
  // Big fields
  'arena.scrap-yard': 'Hurdalık',
  'arena.scrap-foundry': 'Döküm Atölyesi',
  'arena.core-forge': 'Demirhane',
  'arena.brood-nest': 'Yuva',
  'arena.rim-observatory': 'Gözlemevi',
  'arena.rim-shardfield': 'Kristal Tarlası',
  // ADVANCE routes — ▶ marks a room you fight your way through
  'arena.scrap-spine': '▶ Yük Omurgası',
  'arena.scrap-dogleg': '▶ Rıhtım Dirseği',
  'arena.core-conduit': '▶ Magma Kanalı',
  'arena.core-switchback': '▶ Baca Zikzakı',
  'arena.brood-tunnel': '▶ Kuluçka Tüneli',
  'arena.brood-gullet': '▶ Gırtlak',
  'arena.rim-causeway': '▶ Yarık Geçidi',
  'arena.rim-spiral': '▶ Kristal Sarmal',
  'arena.core-crucible': '▶ Pota Yolu',
  'arena.brood-warren': '▶ İnler',
  'arena.rim-fracture': '▶ Kırık Hat',
  // Gate notices
  'map.gateOpen': 'KAPI AÇIK!',
  'map.chamberOpen': 'BOSS ODASI!',
};
